import { FC, memo } from 'react';

import Link from 'next/link';

import { useRecoilValue } from 'recoil';

import { sellerIsLoggedIn } from '@recoil_iqfu/atoms/public/login_state';

import { CompaniesPageCategory } from '@constants_iqfu';

import PointData from './RequestCompaniesSearchToAdmin.json';
import styles from './RequestCompaniesSearchToAdmin.module.scss';
type Props = {
  type: keyof typeof CompaniesPageCategory;
  cityName: string;
};

const RequestCompaniesSearchToAdmin: FC<Props> = memo(({ type, cityName }) => {
  const isLoggedIn = useRecoilValue(sellerIsLoggedIn);

  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>不動産会社選びに迷っていませんか？</p>
      <div className={styles.tag_wrap}>
        <div className={styles.tag_group}>
          <p className={`${styles.tag} ${styles.tag_region}`}>
            <img src="/images/iqfu/public/icon_pin.svg" alt="" className={styles.pin_icon} />
            {cityName}
          </p>
          <img src="/images/iqfu/public/icon_cross.svg" alt="" className={styles.cross_icon} />
        </div>
        <p className={styles.tag}>{PointData[type].tag}</p>
      </div>
      <p className={styles.subtitle}>あなたにぴったりの不動産会社をご紹介！</p>
      <Link href={isLoggedIn ? '/chat/talk?redirect=contact' : '/signup_inquiry'} className={styles.detail_button}>
        不動産会社を探してもらう【無料】
      </Link>
    </div>
  );
});

RequestCompaniesSearchToAdmin.displayName = 'RequestCompaniesSearchToAdmin';

export default RequestCompaniesSearchToAdmin;
